export default {
  methods: {
    mapLayerBikeparkTrailsAdd() {
      this.initPollBikeparkTrails();
      this.map.addSource("bikepark-trails-source", {
        type: "geojson",
        data: this.computedBikeparkTrailsGeoJson
      });

      this.map.addLayer({
        id: "bikepark-trails-labels",
        type: "symbol",
        source: "bikepark-trails-source",
        layout: {
          "symbol-placement": "line",
          "symbol-spacing": 250,
          "symbol-avoid-edges": true,
          "text-font": ["Open Sans Bold"],
          "text-field": "{trail_name}",
          "text-size": 12,
          "text-allow-overlap": true,
          "text-letter-spacing": 0.2
        },
        paint: {
          "text-halo-color": "#FFFFFF",
          "text-halo-width": 3
        }
      });

      this.map.addLayer({
        filter: ["==", "class", "1"],
        id: "bikepark-trails-green",
        type: "line",
        source: "bikepark-trails-source",
        paint: {
          "line-color": "Green",
          "line-width": 3
        }
      });

      this.map.addLayer({
        filter: ["==", "class", "2"],
        id: "bikepark-trails-blue",
        type: "line",
        source: "bikepark-trails-source",
        paint: {
          "line-color": "Blue",
          "line-width": 3
        }
      });

      this.map.addLayer({
        filter: ["==", "class", "3"],
        id: "bikepark-trails-black",
        type: "line",
        source: "bikepark-trails-source",
        paint: {
          "line-color": "Black",
          "line-width": 3
        }
      });

      this.map.addLayer({
        filter: ["==", "class", "3"],
        id: "bikepark-trails-black-halo",
        type: "line",
        source: "bikepark-trails-source",
        paint: {
          "line-color": "White",
          "line-width": 6,
          "line-blur": 3
        }
      });

      this.map.addLayer({
        filter: ["==", "class", "4"],
        id: "bikepark-trails-blackred-black",
        type: "line",
        source: "bikepark-trails-source",
        paint: {
          "line-color": "Black",
          "line-width": 3
        }
      });

      this.map.addLayer({
        filter: ["==", "class", "4"],
        id: "bikepark-trails-blackred-red",
        type: "line",
        source: "bikepark-trails-source",
        paint: {
          "line-color": "Red",
          "line-width": 3,
          "line-dasharray": [3, 3]
        }
      });

      this.map.addLayer({
        filter: ["==", "class", "5"],
        id: "bikepark-trails-red",
        type: "line",
        source: "bikepark-trails-source",
        paint: {
          "line-color": "Red",
          "line-width": 3
        }
      });

      this.map.addLayer({
        filter: ["==", "class", "6"],
        id: "bikepark-trails-orange",
        type: "line",
        source: "bikepark-trails-source",
        paint: {
          "line-color": "Orange",
          "line-width": 3
        }
      });

      this.map.addLayer({
        filter: ["==", "class", "7"],
        id: "bikepark-trails-purple",
        type: "line",
        source: "bikepark-trails-source",
        paint: {
          "line-color": "Purple",
          "line-width": 3
        }
      });

      // Fat finger layer
      this.map.addLayer({
        id: "bikepark-trails-fatfinger",
        type: "line",
        source: "bikepark-trails-source",
        paint: {
          "line-color": "Brown",
          "line-width": 20,
          "line-opacity": 0
        }
      });

      // Hover layer
      this.map.addLayer({
        filter: ["all", ["==", "trail_name", "abc123"]],
        id: "bikepark-trails-hover",
        type: "line",
        source: "bikepark-trails-source",
        paint: {
          "line-color": "Purple",
          "line-width": 10,
          "line-blur": 2
        }
      });

      this.map.moveLayer("bikepark-trails-hover", "marker-layer-lines");
      this.map.moveLayer("bikepark-trails-green", "marker-layer-lines");
      this.map.moveLayer("bikepark-trails-blue", "marker-layer-lines");
      this.map.moveLayer("bikepark-trails-black-halo", "marker-layer-lines");
      this.map.moveLayer("bikepark-trails-black", "marker-layer-lines");
      this.map.moveLayer(
        "bikepark-trails-blackred-black",
        "marker-layer-lines"
      );
      this.map.moveLayer("bikepark-trails-blackred-red", "marker-layer-lines");
      this.map.moveLayer("bikepark-trails-red", "marker-layer-lines");
      this.map.moveLayer("bikepark-trails-orange", "marker-layer-lines");
      this.map.moveLayer("bikepark-trails-purple", "marker-layer-lines");
      this.map.moveLayer("bikepark-trails-labels", "marker-layer-lines");
      this.map.moveLayer("bikepark-trails-fatfinger", "marker-layer-lines");
    },
    mapLayerBikeparkTrailsRemove() {
      this.cancelPollBikeparkTrails();
      this.map.removeLayer("bikepark-trails-labels");
      this.map.removeLayer("bikepark-trails-green");
      this.map.removeLayer("bikepark-trails-blue");
      this.map.removeLayer("bikepark-trails-black");
      this.map.removeLayer("bikepark-trails-black-halo");
      this.map.removeLayer("bikepark-trails-hover");
      this.map.removeLayer("bikepark-trails-blackred-black");
      this.map.removeLayer("bikepark-trails-blackred-red");
      this.map.removeLayer("bikepark-trails-red");
      this.map.removeLayer("bikepark-trails-orange");
      this.map.removeLayer("bikepark-trails-purple");
      this.map.removeLayer("bikepark-trails-fatfinger");
      this.map.removeSource("bikepark-trails-source");
    },
    initPollBikeparkTrails() {
      this.$store.dispatch("actionGetGeoJson", {
        url: "https://api2.alchemymapping.com/vail/whistler/bikepark/trails",
        dept: "bikepark",
        layer: "trails",
        token: this.computedAuthToken
      });
      this.pollBikeparkTrailsInterval = setInterval(() => {
        this.$store.dispatch("actionGetGeoJson", {
          url: "https://api2.alchemymapping.com/vail/whistler/bikepark/trails",
          dept: "bikepark",
          layer: "trails",
          token: this.computedAuthToken
        });
      }, this.computedInterval);
    },
    cancelPollBikeparkTrails() {
      this.pollBikeparkTrailsInterval = clearInterval(
        this.pollBikeparkTrailsInterval
      );
    }
  },
  computed: {
    computedBikeparkTrailsGeoJson() {
      return this.$store.state.mapLayers.bikepark.layers.trails.geojson;
    },
    computedBikeparkTrailsMapVisibility() {
      return this.$store.state.mapLayers.bikepark.layers.trails.visibility
        .mapView;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    computedInterval() {
      return this.$store.state.general.intervalLow;
    }
  },
  watch: {
    "$store.state.mapLayers.bikepark.layers.trails.geojson": {
      handler() {
        if (this.computedBikeparkTrailsGeoJson) {
          this.mapLayerBikeparkTrailsRemove();
          this.mapLayerBikeparkTrailsAdd();
        }
      }
    },
    "$store.state.mapLayers.bikepark.layers.trails.visibility.mapView": function(
      newValue
    ) {
      if (newValue) {
        this.mapLayerBikeparkTrailsAdd();
      } else {
        this.mapLayerBikeparkTrailsRemove();
      }
    }
  },
  beforeDestroy() {
    this.cancelPollBikeparkTrails();
  }
};
